export default "https://legacy.eskolare-development.com/images/order-hero.png";